/* tslint:disable */
/* eslint-disable */
/**
 * B2B Chat
 * Endpoints needed to fetch details and create Kustomer support chat  # Tracking Metrics * `b2bportal.chat_properties.property_type:unknown.error_code:unknown.failure`   * tags: `api_version`, `tenantid` * `b2bportal.chat_properties.property_type:unknown.success`   * tags: `api_version`, `tenantid`
 *
 * The version of the OpenAPI document: v0p12
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Chat conversation containing messages

 * `id` - Unique identifier for the conversation
 * `createdAt` - Creation date of the conversation
 * `messages` - List of messages in the conversation
 * @export
 * @interface ChatConversation
 */
export interface ChatConversation {
    /**
     * Unique identifier for the conversation
     * @type {string}
     * @memberof ChatConversation
     */
    'id': string;
    /**
     * Creation date of the conversation
     * @type {string}
     * @memberof ChatConversation
     */
    'createdAt': string;
    /**
     * List of messages in the conversation
     * @type {Array<ChatMessage>}
     * @memberof ChatConversation
     */
    'messages': Array<ChatMessage>;
}
/**
 * Chat message in a conversation

 * `timestamp` - Timestamp of the message
 * `smartReplies` - Optional list of smart replies for the message
 * `senderRole` - Role of the message sender
 * `id` - Unique identifier for the message
 * `status` - Status of user sent messages. Managed by client
 * `content` - Content of the message
 * `deepLink` - Optional deep link associated with the message
 * @export
 * @interface ChatMessage
 */
export interface ChatMessage {
    /**
     * Timestamp of the message
     * @type {string}
     * @memberof ChatMessage
     */
    'timestamp': string;
    /**
     * Optional list of smart replies for the message
     * @type {Array<string>}
     * @memberof ChatMessage
     */
    'smartReplies'?: Array<string>;
    'senderRole': SenderRole;
    /**
     * Unique identifier for the message
     * @type {string}
     * @memberof ChatMessage
     */
    'id': string;
    'status': Status;
    /**
     * Content of the message
     * @type {string}
     * @memberof ChatMessage
     */
    'content': string;
    'deepLink'?: DeepLink;
}


/**
 * The request to get chat properties for a Kustomer conversation

 * `chatPropertiesType` - The chat properties type
 * `productId` - The product id for the chat properties
 * @export
 * @interface ChatPropertiesRequest
 */
export interface ChatPropertiesRequest {
    'chatPropertiesType': ChatPropertiesType;
    /**
     * The product id for the chat properties
     * @type {string}
     * @memberof ChatPropertiesRequest
     */
    'productId': string;
}


/**
 * The response to a get chat properties call

 * `chatProperties` - The chat properties as a JsObject to be used in the Kustomer conversation, opaque to BFF as Kustomer contract exists in Kremlin only
 * @export
 * @interface ChatPropertiesResponse
 */
export interface ChatPropertiesResponse {
    /**
     * The chat properties as a JsObject to be used in the Kustomer conversation, opaque to BFF as Kustomer contract exists in Kremlin only
     * @type {any}
     * @memberof ChatPropertiesResponse
     */
    'chatProperties': any;
}
/**
 * chat properties product type to be used in request

* `Air` - Air product properties type
* `AirPriceFreeze` - AirPriceFreeze product properties type
* `Default` - Default flow properties type
* `Ground` - Ground product properties type
* `Hotel` - Hotel product properties type
* `HotelDetailsSalesChat` - HotelDetailsSalesChat flow properties type
* `HotelRoomSelectionSalesChat` - HotelRoomSelectionSalesChat flow properties type
* `HotelSearchSalesChat` - HotelSearchSalesChat flow properties type
 * @export
 * @enum {string}
 */

export const ChatPropertiesType = {
    Air: 'Air',
    AirPriceFreeze: 'AirPriceFreeze',
    Default: 'Default',
    Ground: 'Ground',
    Hotel: 'Hotel',
    HotelDetailsSalesChat: 'HotelDetailsSalesChat',
    HotelRoomSelectionSalesChat: 'HotelRoomSelectionSalesChat',
    HotelSearchSalesChat: 'HotelSearchSalesChat'
} as const;

export type ChatPropertiesType = typeof ChatPropertiesType[keyof typeof ChatPropertiesType];


/**
 * The request to close a chat conversation

 * `conversationId` - The ID of the conversation to close
 * `csatComment` - Optional freeform text comment left by user
 * `csatScore` - Optional customer satisfaction rating
 * @export
 * @interface CloseChatConversationRequest
 */
export interface CloseChatConversationRequest {
    'containmentOutcome': ContainmentOutcome;
    /**
     * The ID of the conversation to close
     * @type {string}
     * @memberof CloseChatConversationRequest
     */
    'conversationId': string;
    /**
     * Optional freeform text comment left by user
     * @type {string}
     * @memberof CloseChatConversationRequest
     */
    'csatComment'?: string;
    /**
     * Optional customer satisfaction rating
     * @type {number}
     * @memberof CloseChatConversationRequest
     */
    'csatScore'?: number;
}


/**
 * 

* `Inactivity` - Idle timeout
* `Resolved` - The user closes the conversation without contacting an agent
* `Unresolved` - The user is transferred to an agent
 * @export
 * @enum {string}
 */

export const ContainmentOutcome = {
    Inactivity: 'Inactivity',
    Resolved: 'Resolved',
    Unresolved: 'Unresolved'
} as const;

export type ContainmentOutcome = typeof ContainmentOutcome[keyof typeof ContainmentOutcome];


/**
 * The request to create a new conversation

 * `supportType` - Optional support type for the conversation
 * @export
 * @interface CreateConversationRequest
 */
export interface CreateConversationRequest {
    'supportType'?: SupportType;
}
/**
 * The response to a create conversation call

 * `conversation` - The created chat conversation
 * @export
 * @interface CreateConversationResponse
 */
export interface CreateConversationResponse {
    'conversation': ChatConversation;
}
/**
 * @type DeepLink
 * Deep link types for chat messages
 * @export
 */
export type DeepLink = { DeepLink: 'DeepLinkCarSearch' } & DeepLinkCarSearch | { DeepLink: 'DeepLinkContactSupport' } & DeepLinkContactSupport | { DeepLink: 'DeepLinkFaqArticle' } & DeepLinkFaqArticle | { DeepLink: 'DeepLinkFlightSearch' } & DeepLinkFlightSearch | { DeepLink: 'DeepLinkGlobalHelpCenter' } & DeepLinkGlobalHelpCenter | { DeepLink: 'DeepLinkHotelSearch' } & DeepLinkHotelSearch | { DeepLink: 'DeepLinkTripCancellation' } & DeepLinkTripCancellation | { DeepLink: 'DeepLinkTripDetails' } & DeepLinkTripDetails;

/**
 * `driverAge` - Driver's age
 * `location` - Location name
 * `locationLatitude` - Location latitude
 * `pickupDate` - Pickup date
 * `dropoffDate` - Dropoff date
 * `locationLongitude` - Location longitude
 * @export
 * @interface DeepLinkCarSearch
 */
export interface DeepLinkCarSearch {
    /**
     * Driver's age
     * @type {number}
     * @memberof DeepLinkCarSearch
     */
    'driverAge': number;
    /**
     * Location name
     * @type {string}
     * @memberof DeepLinkCarSearch
     */
    'location': string;
    'DeepLink': DeepLinkEnum;
    /**
     * Location latitude
     * @type {string}
     * @memberof DeepLinkCarSearch
     */
    'locationLatitude': string;
    /**
     * Pickup date
     * @type {string}
     * @memberof DeepLinkCarSearch
     */
    'pickupDate': string;
    /**
     * Dropoff date
     * @type {string}
     * @memberof DeepLinkCarSearch
     */
    'dropoffDate': string;
    /**
     * Location longitude
     * @type {string}
     * @memberof DeepLinkCarSearch
     */
    'locationLongitude': string;
}


/**
 * `productInfo` - Optional product info for a specific booking
 * @export
 * @interface DeepLinkContactSupport
 */
export interface DeepLinkContactSupport {
    'productInfo'?: ProductInfo;
    'DeepLink': DeepLinkEnum;
}


export const DeepLinkEnum = {
    DeepLinkCarSearch: 'DeepLinkCarSearch',
    DeepLinkContactSupport: 'DeepLinkContactSupport',
    DeepLinkFaqArticle: 'DeepLinkFaqArticle',
    DeepLinkFlightSearch: 'DeepLinkFlightSearch',
    DeepLinkGlobalHelpCenter: 'DeepLinkGlobalHelpCenter',
    DeepLinkHotelSearch: 'DeepLinkHotelSearch',
    DeepLinkTripCancellation: 'DeepLinkTripCancellation',
    DeepLinkTripDetails: 'DeepLinkTripDetails'
} as const;

export type DeepLinkEnum = typeof DeepLinkEnum[keyof typeof DeepLinkEnum];


/**
 * `articleHash` - Article hash
 * @export
 * @interface DeepLinkFaqArticle
 */
export interface DeepLinkFaqArticle {
    /**
     * Article hash
     * @type {string}
     * @memberof DeepLinkFaqArticle
     */
    'articleHash': string;
    'DeepLink': DeepLinkEnum;
}


/**
 * `origin` - Origin airport code
 * `destination` - Destination airport code
 * `departureDate` - Departure date
 * `returnDate` - Return date for round trip flights
 * @export
 * @interface DeepLinkFlightSearch
 */
export interface DeepLinkFlightSearch {
    'DeepLink': DeepLinkEnum;
    /**
     * Origin airport code
     * @type {string}
     * @memberof DeepLinkFlightSearch
     */
    'origin': string;
    /**
     * Return date for round trip flights
     * @type {string}
     * @memberof DeepLinkFlightSearch
     */
    'returnDate'?: string;
    /**
     * Destination airport code
     * @type {string}
     * @memberof DeepLinkFlightSearch
     */
    'destination': string;
    /**
     * Departure date
     * @type {string}
     * @memberof DeepLinkFlightSearch
     */
    'departureDate': string;
}


export interface DeepLinkGlobalHelpCenter {
    'DeepLink': DeepLinkEnum;
}


/**
 * `placeId` - Place ID for hotel search
 * `searchTerm` - Search term for the hotel search
 * `checkIn` - Check-in date
 * `checkOut` - Check-out date
 * @export
 * @interface DeepLinkHotelSearch
 */
export interface DeepLinkHotelSearch {
    /**
     * Place ID for hotel search
     * @type {string}
     * @memberof DeepLinkHotelSearch
     */
    'placeId': string;
    'DeepLink': DeepLinkEnum;
    /**
     * Search term for the hotel search
     * @type {string}
     * @memberof DeepLinkHotelSearch
     */
    'searchTerm': string;
    /**
     * Check-in date
     * @type {string}
     * @memberof DeepLinkHotelSearch
     */
    'checkIn': string;
    /**
     * Check-out date
     * @type {string}
     * @memberof DeepLinkHotelSearch
     */
    'checkOut': string;
}


/**
 * `productInfo` - product info for a specific booking
 * @export
 * @interface DeepLinkTripCancellation
 */
export interface DeepLinkTripCancellation {
    'productInfo': ProductInfo;
    'DeepLink': DeepLinkEnum;
}


/**
 * `productInfo` - product info for a specific booking
 * @export
 * @interface DeepLinkTripDetails
 */
export interface DeepLinkTripDetails {
    'productInfo': ProductInfo;
    'DeepLink': DeepLinkEnum;
}


/**
 * Product Info for deep links

 * `travelCategory` - Travel category
 * `itineraryUuid` - Itinerary UUID
 * `hopperId` - Hopper Short ID
 * @export
 * @interface ProductInfo
 */
export interface ProductInfo {
    /**
     * Travel category
     * @type {string}
     * @memberof ProductInfo
     */
    'travelCategory': string;
    /**
     * Itinerary UUID
     * @type {string}
     * @memberof ProductInfo
     */
    'itineraryUuid': string;
    /**
     * Hopper Short ID
     * @type {string}
     * @memberof ProductInfo
     */
    'hopperId': string;
}
/**
 * The request to send a chat message

 * `conversationId` - The ID of the conversation to send the message to
 * `message` - The content of the message to send
 * `supportType` - Optional support type for the chat message
 * @export
 * @interface SendChatMessageRequest
 */
export interface SendChatMessageRequest {
    /**
     * The ID of the conversation to send the message to
     * @type {string}
     * @memberof SendChatMessageRequest
     */
    'conversationId': string;
    /**
     * The content of the message to send
     * @type {string}
     * @memberof SendChatMessageRequest
     */
    'message': string;
    'supportType'?: SupportType;
}
/**
 * The response to a send chat message call

 * `message` - The chat message response
 * @export
 * @interface SendChatMessageResponse
 */
export interface SendChatMessageResponse {
    'message': ChatMessage;
}
/**
 * Sender role for chat messages

* `Agent` - Agent role
* `User` - User role
 * @export
 * @enum {string}
 */

export const SenderRole = {
    Agent: 'Agent',
    User: 'User'
} as const;

export type SenderRole = typeof SenderRole[keyof typeof SenderRole];


/**
 * Status of user sent messages. Managed by client
 * @export
 * @enum {string}
 */

export const Status = {
    Failed: 'Failed',
    Pending: 'Pending',
    Sent: 'Sent'
} as const;

export type Status = typeof Status[keyof typeof Status];


/**
 * Support Type for a chatbot conversation

 * `travelCategory` - Travel category
 * `itineraryUuid` - Itinerary UUID
 * @export
 * @interface SupportType
 */
export interface SupportType {
    /**
     * Travel category
     * @type {string}
     * @memberof SupportType
     */
    'travelCategory': string;
    /**
     * Itinerary UUID
     * @type {string}
     * @memberof SupportType
     */
    'itineraryUuid': string;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Closes a chat-bot conversation
         * @param {CloseChatConversationRequest} closeChatConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ChatbotClosePut: async (closeChatConversationRequest: CloseChatConversationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'closeChatConversationRequest' is not null or undefined
            assertParamExists('apiV0ChatbotClosePut', 'closeChatConversationRequest', closeChatConversationRequest)
            const localVarPath = `/api/v0/chatbot/close`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(closeChatConversationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new chat-bot conversation
         * @param {CreateConversationRequest} createConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ChatbotCreatePut: async (createConversationRequest: CreateConversationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createConversationRequest' is not null or undefined
            assertParamExists('apiV0ChatbotCreatePut', 'createConversationRequest', createConversationRequest)
            const localVarPath = `/api/v0/chatbot/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createConversationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends a message to a chat-bot conversation
         * @param {SendChatMessageRequest} sendChatMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ChatbotSendMessagePut: async (sendChatMessageRequest: SendChatMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendChatMessageRequest' is not null or undefined
            assertParamExists('apiV0ChatbotSendMessagePut', 'sendChatMessageRequest', sendChatMessageRequest)
            const localVarPath = `/api/v0/chatbot/sendMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendChatMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches the Kustomer chat properties for a specific product to start a support chat with agent 
         * @param {ChatPropertiesRequest} chatPropertiesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SupportChatPropertiesPut: async (chatPropertiesRequest: ChatPropertiesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatPropertiesRequest' is not null or undefined
            assertParamExists('apiV0SupportChatPropertiesPut', 'chatPropertiesRequest', chatPropertiesRequest)
            const localVarPath = `/api/v0/support/chatProperties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatPropertiesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Closes a chat-bot conversation
         * @param {CloseChatConversationRequest} closeChatConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ChatbotClosePut(closeChatConversationRequest: CloseChatConversationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ChatbotClosePut(closeChatConversationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0ChatbotClosePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new chat-bot conversation
         * @param {CreateConversationRequest} createConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ChatbotCreatePut(createConversationRequest: CreateConversationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateConversationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ChatbotCreatePut(createConversationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0ChatbotCreatePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends a message to a chat-bot conversation
         * @param {SendChatMessageRequest} sendChatMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ChatbotSendMessagePut(sendChatMessageRequest: SendChatMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendChatMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ChatbotSendMessagePut(sendChatMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0ChatbotSendMessagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches the Kustomer chat properties for a specific product to start a support chat with agent 
         * @param {ChatPropertiesRequest} chatPropertiesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0SupportChatPropertiesPut(chatPropertiesRequest: ChatPropertiesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatPropertiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0SupportChatPropertiesPut(chatPropertiesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0SupportChatPropertiesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Closes a chat-bot conversation
         * @param {CloseChatConversationRequest} closeChatConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ChatbotClosePut(closeChatConversationRequest: CloseChatConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.apiV0ChatbotClosePut(closeChatConversationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new chat-bot conversation
         * @param {CreateConversationRequest} createConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ChatbotCreatePut(createConversationRequest: CreateConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateConversationResponse> {
            return localVarFp.apiV0ChatbotCreatePut(createConversationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends a message to a chat-bot conversation
         * @param {SendChatMessageRequest} sendChatMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ChatbotSendMessagePut(sendChatMessageRequest: SendChatMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendChatMessageResponse> {
            return localVarFp.apiV0ChatbotSendMessagePut(sendChatMessageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches the Kustomer chat properties for a specific product to start a support chat with agent 
         * @param {ChatPropertiesRequest} chatPropertiesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SupportChatPropertiesPut(chatPropertiesRequest: ChatPropertiesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatPropertiesResponse> {
            return localVarFp.apiV0SupportChatPropertiesPut(chatPropertiesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Closes a chat-bot conversation
     * @param {CloseChatConversationRequest} closeChatConversationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0ChatbotClosePut(closeChatConversationRequest: CloseChatConversationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0ChatbotClosePut(closeChatConversationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new chat-bot conversation
     * @param {CreateConversationRequest} createConversationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0ChatbotCreatePut(createConversationRequest: CreateConversationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0ChatbotCreatePut(createConversationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends a message to a chat-bot conversation
     * @param {SendChatMessageRequest} sendChatMessageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0ChatbotSendMessagePut(sendChatMessageRequest: SendChatMessageRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0ChatbotSendMessagePut(sendChatMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches the Kustomer chat properties for a specific product to start a support chat with agent 
     * @param {ChatPropertiesRequest} chatPropertiesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0SupportChatPropertiesPut(chatPropertiesRequest: ChatPropertiesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0SupportChatPropertiesPut(chatPropertiesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



